import { render, staticRenderFns } from "./OpenLinksTecDialog.vue?vue&type=template&id=621dc336"
import script from "./OpenLinksTecDialog.vue?vue&type=script&lang=js"
export * from "./OpenLinksTecDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports